import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Icon from '../../../../Icon';
import brandConfig, { isFlagler } from '../../../../../constants/brandConfig';

import styles from './styles.styl';

function Placeholder({
  icon,
  title,
  subtitle,
  extraSubtitle,
  subtitleClassName,
  intl: { formatMessage },
}) {
  return (
    <div className={styles.placeholder}>
      {icon || (
        <Icon
          size={64}
          name={brandConfig.logo}
          style={{ ...(isFlagler && { fill: brandConfig.fillColor }) }}
        />
      )}
      <span className={cn(styles.title, subtitleClassName)}>
        {formatMessage({ id: title })}
      </span>
      <span className={cn(styles.subtitle, subtitleClassName)}>
        {formatMessage({ id: subtitle })}
      </span>

      {extraSubtitle && (
        <span className={styles.subtitle}>
          {formatMessage({ id: extraSubtitle })}
        </span>
      )}
    </div>
  );
}

Placeholder.propTypes = {
  icon: PropTypes.node,
  intl: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  extraSubtitle: PropTypes.string,
  subtitleClassName: PropTypes.string,
};

export default injectIntl(Placeholder);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/ActiveSpeaker/Placeholder/index.jsx